import React from "react";
import { Form } from "antd";
import AddressInput from "../../Inputs/AddressInput";

const RouteStartLocationForm = ({ driverId, address, lat, lng, onSubmit }) => {
  const [form] = Form.useForm();

  const handleOnFinish = async values => {
    const params = {
      startAddress: values["startAddress"].address,
      startLat: values["startAddress"].latLng.lat,
      startLng: values["startAddress"].latLng.lng,
    };
    onSubmit({ driver: driverId, ...params });
  };

  const handleOnChangeAddress = startAddress => {
    form.setFieldsValue({ startAddress });
    form.submit();
  };

  return (
    <Form
      form={form}
      initialValues={{
        startAddress: {
          address: address,
          latLng: { lat, lng },
        },
      }}
      onFinish={handleOnFinish}>
      <Form.Item name="startAddress" rules={[{ required: true }]} style={{ margin: 0 }}>
        <AddressInput onSelect={handleOnChangeAddress} />
      </Form.Item>
    </Form>
  );
};

export default RouteStartLocationForm;
